/**
 * User: Faris
 * Date: 6/24/13
 * Time: 4:30 PM
 */

define('app/views/page',['require','./baseview'],function(require) {

  var BaseView = require('./baseview');

  var HEADER_OFFSET = 130;
  var MOBILE_CAROUSEL_RATIO = 550/1000;

  return BaseView.extend({

    view: 'page',
    viewportHeight: 0,

    defaults: {
      preload: true
    },

    events: {
      'click .scroll-indicator': 'onClickScrollIndicator'
    },

    initialize: function(options){
      BaseView.prototype.initialize.call(this, options);

      _.bindAll(this,
        'onClickScrollIndicator',
        'onScroll'
      );

      if(this.model) {
        var slides = this.model.get('SLIDES');
        if (slides && slides.length) {
          this.assets.push('/content/slides/' + slides[0].IMAGE);
        }
      }

      $(window).scroll(this.onScroll);
    },

    show: function(){
      TweenMax.fromTo(this.$el, 0.75, { alpha: 0, onComplete: this.afterShow }, { alpha: 1 });
      return this;
    },

    hide: function(){
      TweenMax.fromTo(this.$el, 0.75, { alpha: 1, onComplete: this.afterHide }, { alpha: 0 });
      return this;
    },

    afterHide: function(){
      BaseView.prototype.afterHide.call(this);
      this.$el.detach();
    },

    onClickScrollIndicator: function(e){
      var finalScroll = $(e.target).hasClass('scroll-up') ? 0 : (this.viewportHeight - HEADER_OFFSET);
      TweenMax.to(window, 0.75, { scrollTo: { y: finalScroll }, ease: Power2.easeInOut, onComplete: function(){
        $(window).scroll();
      }});
    },

    onResize: function(e){
      var windowWidth = $(window).width();
      var windowHeight = Math.min($(window).height(), (window.innerHeight || $(window).innerHeight()));
      var headerHeight = $('header:visible').outerHeight(true);
      var footerHeight = $('footer').outerHeight(true);
      this.viewportHeight = windowHeight - headerHeight - footerHeight;

      if(windowWidth > 768){
        //greater than ipad portrait, crop images
        $('.header, .sticky', this.$el).height(this.viewportHeight);
        $('.body', this.$el).css({ minHeight: this.viewportHeight - HEADER_OFFSET });
      } else {
        //ipad portrait, 100% width images and maintain aspect ratio for height
        var height = $('.header', this.$el).width() * MOBILE_CAROUSEL_RATIO;
        $('.header, .sticky', this.$el).height(Math.ceil(height));
        $('.body', this.$el).css({ minHeight: this.viewportHeight - HEADER_OFFSET });
      }

      this.onScroll();
    },

    onScroll: function(e){
      var scrollTop = $(window).scrollTop();
      var headerHeight = $('header:visible').outerHeight(true);
      var sticky = $('.sticky', this.$el);
      var fixedThreshold =  this.viewportHeight - HEADER_OFFSET;
      var fixedTop = headerHeight - this.viewportHeight + HEADER_OFFSET;

      //determine whether carousel should be fixed as a header
      sticky.toggleClass('fixed', scrollTop >= fixedThreshold);

      //if its fixed, set its top position correctly
      if(sticky.is('.fixed')){
        sticky.css({ top: fixedTop });
      }

      $('.scroll-indicator', this.$el).toggleClass('scroll-up', scrollTop != 0);
    }

  });

});
